import * as React from "react";
import {Button, Col, Container, Row} from "react-bootstrap";
import {Card} from "react-bootstrap";
import PricingButton from "./components/PricingButton";
import {Helmet} from "react-helmet";
import {useEffect, useState} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import API from "./api";
import Badge from 'react-bootstrap/Badge';
import Spinner from "react-bootstrap/Spinner";
import Stack from "react-bootstrap/Stack";
import PricingCarousel from "./components/PricingCarousel";
import PricingFaq from "./components/PricingFaq";

// Stable code of the hidden "Chris Tyler Exclusive" plan (see WorkWithChris.js).
// The "Want to work exclusively with Chris?" button below only shows while
// this plan is active — Chris toggles it off via Admin > Edit Plan when he
// wants to pause the offer without a redeploy (e.g. mid-promo, Slack Jul 24).
const EXCLUSIVE_PLAN_CODE = "chris-tyler-exclusive";

function useQuery() {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
}

function InstructorPricing() {
	const [plans, setPlans] = useState()
	const [chrisPlan, setChrisPlan] = useState(null)
	let query = useQuery();
	// Default to Chris Tyler (15) — the only active instructor today — so the
	// clean canonical URL (/pricing, no route param) works the same as the
	// legacy per-instructor URL (/pricing/instructor/15).
	let { instructorId = "15" } = useParams();
	const [isLoading, setLoading] = useState(false)
	const navigate = useNavigate();

	useEffect(() => {
		setTimeout(() => {
			setLoading(true);
			API.get(`plans/instructor/${instructorId}`)
				.then(response => {
					if (response.data.instructor === null || !response.data.plans.length) {
						navigate("/dna-profile", { replace: true });
					}
					setPlans(response.data);
					return response.data;
				})
				.finally(() => setLoading(false));



		}, 0);
	}, [instructorId])

	useEffect(() => {
		API.get(`plans/code/${EXCLUSIVE_PLAN_CODE}`)
			.then((response) => setChrisPlan(response.data))
			.catch(() => setChrisPlan(null));
	}, [])


	const cadenceMap = {
		'MONTHLY': 'month',
		'ANNUAL': 'annual',
	}

	function insertDecimal(num) {
		return Number((num / 100).toFixed(2));
	}

	return (
		<>
			<Helmet>
				<title>Pricing | MyGolfDNA.com</title>
				<meta name="description" content="Pricing and Plans"/>
			</Helmet>
			<div id="pricing-page">
				<div className="" id="video" style={{backgroundColor: '#fff', paddingTop: 40, paddingBottom: 40}}>
				<Container>
					<h1 className="text-center monument-font-black text-primary text-uppercase">Get full access for less than a single,<br/> in-person lesson</h1>
					<p className="text-black-50 text-center mb-4" style={{fontWeight: 300, fontSize: 24}}>With a Risk-Free 30-Day Money-Back Guarantee</p>
						<Row className="justify-content-center">
							<Col lg={10}>
								<div className="" style={{padding:'56.25% 0 0 0',position:'relative', height: 0, overflow: 'hidden', maxWidth: '100%'}}>
									<iframe
										src={`https://player.vimeo.com/video/${plans?.instructor.vimeoId || 827001005}?h=521d44fbfb&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
										frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
										style={{position:'absolute',top:0,left:0,width:'100%',height:'100%'}} title="Why mygolfdna and pocket pro mixed for sales page"/>
								</div>
							</Col>
						</Row>
				</Container>
				</div>
				<div id="plans" className="" style={{backgroundColor: '#fafbfd', paddingTop: 40, paddingBottom: 40}}>
					<Container>
						<Row className="pt-4 justify-content-center">
							{isLoading ?
								<div className="p-4" style={{textAlign: 'center'}}> <Spinner className="text-orange" animation="border" /></div> :
								plans?.plans.map((plan, index) => (
									<Col lg={plans.plans.length >= 4 ? 3 : 4} md={12} sm={12} key={index} className="mb-lg-0 mb-4">
										<Card className={`${plan.mostPopular ? 'border-secondary' : ''}`}>
											<Card.Body>
												<div className="d-grid gap-2">
													<Card.Title className=" text-capitalize">
														<Stack direction="horizontal" gap={3}>
															<div className="p-2">{plan.planName}</div>
															{plan.mostPopular ?
																<div className="p-2 ms-auto"><Badge bg="success" style={{fontSize: 12}}>Best Value</Badge></div>
																:
																''
															}
														</Stack>
													</Card.Title>
													<div className="d-flex align-items-center gap-1">
														<div className="h1">
															${insertDecimal(plan.amount)}
														</div>
														/<small className="">{cadenceMap[plan.cadence]}</small>
													</div>
													<PricingButton
														href={`/plans/${plan.sourceId}`}
														plan={plan.sourceId}
													>
														Get Started Now
													</PricingButton>
													<div className="pt-4 mt-4 " style={{borderTop: '2px solid #eee'}}>
														<Stack gap={2}>
															<div className="plan-description" dangerouslySetInnerHTML={{__html: plan.description}}>
															</div>
														</Stack>

													</div>




												</div>
											</Card.Body>
										</Card>
									</Col>
								))}
						</Row>
						{!isLoading && chrisPlan && (
							<Row className="pt-5 justify-content-center">
								<Col xs="auto">
									<Button
										as={Link}
										to="/work-with-chris"
										variant="success"
										size="lg"
										className="fw-semibold"
									>
										Want to work exclusively with Chris?
									</Button>
								</Col>
							</Row>
						)}
					</Container>

				</div>
				<div className="" id="testimonials" style={{backgroundColor: '#fafbfd', paddingTop: 40}}>
						<Container>
							<Row>
								<Col>
									<h3 className="text-center monument-font-black text-primary text-uppercase">Testimonials</h3>
									<p className="text-black-50 text-center mb-4" style={{fontWeight: 300, fontSize: 20}}>What Students Are Saying About Our Instruction</p>
									<PricingCarousel />
								</Col>
							</Row>
						</Container>
				</div>
				<div className="" id="faqs" style={{paddingTop: 40, paddingBottom: 40}}>
				<Container>
					<Row className="justify-content-center">
						<Col lg={8}>
								<h3 className="text-center monument-font-black text-primary text-uppercase">Frequently asked Questions</h3>
							<p className="text-black-50 text-center" style={{fontWeight: 300, fontSize: 20}}>Can’t find the answer you’re looking for?
								<br/>Feel free to reach out to us at <b>support@mygolfdna.com</b> – we’re here to help!</p>


							<PricingFaq />
							</Col>
					</Row>
				</Container>
				</div>
			</div>

		</>
	)
}

export default InstructorPricing;
